const { cELM, Wrap4ArrowMulti } = require("../../utils");
const Chat = require("../../chat");

class BloodPressureInput {
  constructor(data) {
    this.data = data;
    this.element = cELM("div", "option-block");
    this.__elements = null;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;
    const inputContainer = cELM("div", "inputs-wrapper");
    const lowEl = cELM("input", "number-input");
    const highEl = cELM("input", "number-input");

    lowEl.type = "number";
    lowEl.pattern = "[0-9]*";
    lowEl.placeholder = "Low";
    highEl.type = "number";
    highEl.pattern = "[0-9]*";
    highEl.placeholder = "High";

    const buttonEl = cELM("div", "continue-button continue-button-active", "Continue");

    buttonEl.onclick = function(evt) {
      const op = lowEl.value + "/" + highEl.value;
      if (lowEl.value && highEl.value) {
        Chat.default.send({
            text: op,
            id: _self.data.id
          }, 
          null, 
          _self.element
        );
      }
    };

    inputContainer.addELM(Wrap4ArrowMulti(lowEl, true));
    inputContainer.addELM(cELM("div", "slash", "/"));
    inputContainer.addELM(Wrap4ArrowMulti(highEl));
    this.element.addELM(inputContainer);
    this.element.addELM(buttonEl);
    this.__elements = { lowEl, highEl };
    return this.element;
  }

  reset() {
    if (!this.__elements) return;
    this.__elements.lowEl.value = "";
    this.__elements.highEl.value = "";
    this.__elements.lowEl.focus();
  }

  focus() {
    //this.__elements.lowEl.focus();
  }
}

module.exports = BloodPressureInput;
